<template>
  <v-row>
    <v-col cols="6">
      <h3>General Terms & Conditions</h3>
      1. LBL P/L t/a BBG reserves the rights to reject any advertisement which
      it considers unsuitable for publication or which it declines to publish
      for any other reason at its absolute discretion. <br />2. While every
      endeavour will be made to ensure the insertion of an advertisement in
      accordance with the advertiser’s instructions, no liability whatever will
      be accepted for any loss or damage occasioned by any error or omission or
      misplacement or by late or delayed publication or distribution. <br />3.
      It is the responsibility of the advertiser or its agent to notify LBP P/L
      t/a BBG of any error immediately after publication and LBP P/L t/a BBG
      shall not be responsible for the republication of any error not notified
      to it. All advertisements lodged with LBP P/L t/a BBG must comply with the
      Regulation and Advertising Codes of the Media Council of Australia and
      with the interpretations of Advertising Standards Council. <br />4. The
      positioning of Advertisements shall be at the discretion of LBP P/L t/a
      BBG. Without limiting this discretion, whatever special arrangements have
      been made and payment of appropriate loading charges agreed to, LBP P/L
      t/a BBG will make every endeavour to position advertisements as agreed, in
      particular special placements are subject to space availability at the
      time of printing. <br />5. Receipt of copy by whatever means shall
      constitute and order for publication of the advertisements. <br />6. BBG
      savings card members are committed to offer the savings nominated in their
      advertisements. <br />7. LBP P/L t/a BBG guarantees advertisements in
      publication will run for the term specified under the Booking Contract.
      <br />8. The advertiser or agency accepts full responsibility for the term
      specified under the Booking Contract identify LBP P/L t/a BBG and all its
      employee and agents against any liability whatsoever to any person or
      corporation (other than the advertiser) which may arise from such
      publication, including, without limiting the generality of the foregoing,
      liability for negligence or want of care of LBP P/L t/a BBG or any
      employee or agent LBP P/L t/a BBG.
    </v-col>
    <v-col cols="6">
      <br />9. Late payments made after publication will incur current bank
      interest rates. <br />10. The client indemnifies LBP P/L t/a BBG legally
      for any problem caused by billboard affixed to clients vehicle and/or
      building. <br />11. LBP P/L t/a BBG prints an advertisement containing an
      error or fails to print an advertisement in an agreed position or fails to
      print an advertisement or distribute the printed booklet at a time when it
      was scheduled to be published or distributed, LBP P/L t/a BBG or any
      employee or agent shall incur no liability whatsoever to the advertiser or
      agency of LBP P/L t/a BBG beyond, at the discretion of the advertiser, an
      undertaking to print the advertisement again at a convenient time.
      <h3>Cancellation Terms & Conditions</h3>
      <br />12. Cooling off period is three (3) working days of booking.
      Cancellation made with the accepted period forfeit 35% of sale amount,
      which will be deducted using the payment method nominated. Bookings under
      $660 are not eligible for cancellation after the cooling off period.
      <br />13. The client may cancel at any time after the first three (3)
      months from the booking date. <br />14. Cancellation or Alteration of
      booking contract will be accepted anytime with 45-days notice prior to
      print. <br />15. Cancellation,
      Alterations & Artwork changes must be in writing, signed and sent to LBP
      P/L t/a BBG by Registered Mail or email. These will not be accepted
      verbally. It is responsibility of the advertiser or its agent to notify
      LBP P/L t/a BBG of any changes to contact details. <br />16. All internet
      advertising is displayed for the term specified under the booking contract
      as of date uploaded and becoming live. Where sold as package of internet
      advertising, SMS service and/or printed advertising cannot be separated
      for cancellation. <br />17. Cancellation and/or downgrading of items of
      which are part of a package, will incur full priced rates on the remainder
      of items voiding any discount given. <br />18. Heavily discounted packages
      made through an agent of LBP P/L t/a BBG are subject to management
      approval and may be rejected upon contract submission.
    </v-col>
  </v-row>
</template>

<script>
export default {}
</script>

<style></style>
